import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Flex, Grid,
    Heading,
    Input,
    InputGroup, Spacer, Spinner,
    Stack, Text,
    useToast
} from "@chakra-ui/react";
import * as React from 'react';
import {FC, useEffect, useState} from "react";
import SessionCard from "../../components/sessionCard";
import axios from "axios";
import api from "../../services/api";
import Filters from "../../components/filters";
import PiperzStudioIcon from "../../styles/icons/PiperzStudioIcon";
import RedirectIcon from "../../styles/icons/RedirectIcon";
import {BsWhatsapp} from "react-icons/bs";
import {getSessionStatusColor, getSessionStatusDescription} from "../../enum/session/SessionStatus";
import {format} from "date-fns";
import {phoneToWhatsApp} from "../../util/phone-number";
import {Type} from "../../enum/log/type";


interface SessionListTodayCardProps {
    session: {id:string; status:string;
        scheduled_for: string; client:{name:string, logo:string}; address_numero:string; address_rua:string; address_bairro:string; address_cidade: string; address_estado: string;
        items:{id: string; title: string}[]; scheduling_responsible_info: string; created_at: string; scheduling_responsible_info_extra: string; briefing_pre: string; scheduling_responsible_info_phone:string; key_pickup_address:string;
        user:{name:string},provider_access_text?: string | null; address_link:string, short_address:string, key_pickup_address_link: string, SessionCheckStartProvider: boolean, SessionCheckEndProvider: boolean, confirmation_message: string,
        session_vertical_data_unit: string, session_vertical_data_complement: string, session_vertical_data_area: string, session_vertical_data_reference: string, session_vertical_data_keys: string,
    }
    reminder?: boolean
    bg?: string
}


const SessionListTodayCard: FC<SessionListTodayCardProps> = ({session, reminder= false, bg='#ffff'}) => {


    const whatsAppNotification = phoneToWhatsApp(
        session.scheduling_responsible_info_phone,
        `${
            session?.confirmation_message
        }`
    );

    const saveLog = (value: any) => {
        api.post(`/provider/sessions/log/${session.id}/${value}`)
    }

    return (
        <>
            <Flex as={'a'} href={`/ensaios/${session.id}`} bg={bg} shadow={'0px  0px 7px #97A4B6'} borderRadius={'2xl'} flexDirection={'column'} p={'5'}>
                <Flex justifyContent={'space-between'} alignItems={'center'}>
                    <Avatar name={session.client.name} src={session.client.logo}/>
                    <Text bg={getSessionStatusColor(Number(session.status))} color={'white'} p={'1'} px={'6'} borderRadius={'2xl'}>{getSessionStatusDescription(Number(session.status))}</Text>
                </Flex>
                <Flex flexDirection={'column'} gap={'0.5'} mt={'3'}>
                    <Text fontWeight={'500'} fontSize={'16px'}>{format(new Date(session.scheduled_for), "HH:mm")} &bull; {new Date(session.scheduled_for).toLocaleDateString(
                            "pt-BR",
                            {
                                day: "2-digit",
                                month: "2-digit",
                            }
                        )}
                        {/*{new Date(session.scheduled_for).toLocaleDateString(*/}
                        {/*    "pt-BR",*/}
                        {/*    {*/}

                        {/*    }*/}
                        {/*)}*/}
                    </Text>
                    <Text fontWeight={'500'} fontSize={'14px'} color={'gray.600'}>ID {session.id} &bull; Ref Int. {session.session_vertical_data_reference}</Text>
                    <Text fontWeight={'400'} fontSize={'14px'} color={'gray.600'}>{session.address_rua}, {session.address_numero} &bull; {session.address_bairro}, {session.address_cidade}, {session.address_estado}</Text>
                </Flex>
                <Flex mt={3} overflowX="auto">
                    <Flex gap={'2'}>

                        {session.items.map(value =>
                            <Grid column={'3'} >
                                <Flex overscroll={'auto'} gap={2}>
                                    <Flex my={'auto'} p={'2'} maxH={8} bg={'#E3FFED'} borderRadius={'2xl'}>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7 10.7906C7.86437 10.7906 8.60002 10.4921 9.20698 9.89518C9.81393 9.29822 10.1174 8.57468 10.1174 7.72455C10.1174 6.87442 9.81393 6.15088 9.20698 5.55392C8.60002 4.95697 7.86437 4.65849 7 4.65849C6.13563 4.65849 5.39997 4.95697 4.79302 5.55392C4.18607 6.15088 3.8826 6.87442 3.8826 7.72455C3.8826 8.57468 4.18607 9.29822 4.79302 9.89518C5.39997 10.4921 6.13563 10.7906 7 10.7906ZM1.33199 13.1598C0.959788 13.1598 0.644738 13.033 0.386843 12.7794C0.128948 12.5257 0 12.2159 0 11.8498V3.59931C0 3.23324 0.128948 2.92338 0.386843 2.66973C0.644738 2.41608 0.959788 2.28926 1.33199 2.28926H3.58219L4.94535 0.839844H9.05465L10.4178 2.28926H12.668C13.0402 2.28926 13.3553 2.41608 13.6132 2.66973C13.8711 2.92338 14 3.23324 14 3.59931V11.8498C14 12.2159 13.8711 12.5257 13.6132 12.7794C13.3553 13.033 13.0402 13.1598 12.668 13.1598H1.33199Z"
                                                fill="#00D99D"/>
                                            <path
                                                d="M8.96 7.83984C8.96 8.92232 8.08248 9.79984 7 9.79984C5.91752 9.79984 5.04 8.92232 5.04 7.83984C5.04 6.75737 5.91752 5.87984 7 5.87984C8.08248 5.87984 8.96 6.75737 8.96 7.83984Z"
                                                fill="#00D99D"/>
                                        </svg>
                                    </Flex>
                                    <Text my={'auto'}>{value.title}</Text>
                                </Flex>

                            </Grid>
                        )}
                    </Flex>
                </Flex>
                {session.provider_access_text &&
                    <Flex mt={2} gap={2}>
                        <Flex p={'2'} bg={'#E3FFED'} borderRadius={'2xl'}>
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.6519 5.49742C4.06698 5.49742 4.4208 5.35214 4.71337 5.06158C5.00592 4.77102 5.1522 4.41821 5.1522 4.00313C5.1522 3.58804 5.00692 3.23421 4.71637 2.94164C4.42581 2.64909 4.07299 2.50281 3.65789 2.50281C3.24281 2.50281 2.88899 2.64809 2.59643 2.93864C2.30387 3.2292 2.15759 3.58202 2.15759 3.9971C2.15759 4.41219 2.30287 4.76602 2.59343 5.05858C2.88398 5.35114 3.23681 5.49742 3.6519 5.49742ZM3.6549 7.65501C2.6331 7.65501 1.76851 7.30131 1.06111 6.5939C0.353704 5.8865 0 5.02191 0 4.00011C0 2.97832 0.353704 2.11372 1.06111 1.40633C1.76851 0.698919 2.6331 0.345215 3.6549 0.345215C4.45487 0.345215 5.17908 0.578834 5.82753 1.04607C6.47598 1.51331 6.90238 2.09495 7.10674 2.79099H12.8095C12.8922 2.79099 12.9719 2.80584 13.0489 2.83553C13.1258 2.86522 13.1983 2.91412 13.2664 2.98224L13.8028 3.51864C13.8635 3.57937 13.9116 3.6487 13.9469 3.72664C13.9823 3.80457 14 3.88656 14 3.97261C14 4.05469 13.9812 4.13678 13.9437 4.21888C13.9061 4.30098 13.8564 4.37332 13.7944 4.4359L12.4359 5.8162C12.3782 5.87441 12.3084 5.91837 12.2263 5.94807C12.1442 5.97776 12.0643 5.99478 11.9865 5.99916C11.9088 6.00352 11.8307 5.98976 11.7521 5.95789C11.6735 5.92601 11.6029 5.88374 11.5403 5.83107L10.7355 5.10705L9.86083 5.87691C9.80379 5.92959 9.74028 5.97078 9.67029 6.00047C9.6003 6.03016 9.52439 6.045 9.44254 6.045C9.3648 6.045 9.28707 6.03016 9.20935 6.00047C9.13162 5.97078 9.06366 5.93119 9.00545 5.88172L8.21375 5.17517H7.10674C6.90675 5.87646 6.47729 6.46509 5.81837 6.94106C5.15944 7.41703 4.43828 7.65501 3.6549 7.65501Z" fill="#00D99D"/>
                            </svg>
                        </Flex>
                        {session.provider_access_text}
                    </Flex>
                }
                {
                    reminder &&
                    <Button
                        onClick={()=>saveLog(Type.PROVIDER_MESSAGE_CONFIMATION)}
                        mt={3}
                        colorScheme="whatsapp"
                        rightIcon={<BsWhatsapp />}
                        as={"a"}
                        href={whatsAppNotification}
                        target={"_blank"}
                    >
                        <Text>Lembrar anfitrião</Text>
                    </Button>
                }
            </Flex>
        </>
    );
};

export default SessionListTodayCard;
